import { AttractionTypesList } from '@/components/attraction-types';
import { attractionTypeCrudConfig, type AttractionType } from '@/config/objects/attraction-types';
import { useAttractionCategoryContext } from '@/pages/attraction-categories/useAttractionCategoryContext';
import { Loading, useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function AttractionCategoryAttractionTypesTab() {
  const { id } = useParams<{ id: string }>();
  const { attractionCategory, isLoading } = useAttractionCategoryContext();
  const apiClient = useApiClient();

  const attractionCategoryAttractionTypesConfig: CrudConfig<AttractionType> = useMemo(
    () => ({
      ...attractionTypeCrudConfig,
      entityName: 'Attraction Type',
      entityNamePlural: 'Attraction Types',
      endpoints: {
        ...attractionTypeCrudConfig.endpoints,
        list: `/attraction-categories/${id}/attraction-types`,
        delete: (attractionTypeId: string) =>
          `/attraction-categories/${id}/attraction-types/${attractionTypeId}`,
      },
      listView: {
        ...attractionTypeCrudConfig.listView,
        actions: {
          add: {
            enabled: true,
            endpoint: '/attraction-types',
            where: attractionCategory
              ? {
                  categories: {
                    none: {
                      attractionCategoryId: attractionCategory.id,
                    },
                  },
                }
              : undefined,
            onAdd: async (attractionType: AttractionType) => {
              await apiClient.post(`/attraction-categories/${id}/attraction-types`, {
                attractionTypeId: attractionType.id,
              });
              toast.success('Attraction type added to attraction category');
            },
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (attractionType: AttractionType) => {
              await apiClient.delete(
                `/attraction-categories/${id}/attraction-types/${attractionType.id}`,
              );
              toast.success('Attraction type removed from attraction category');
            },
          },
        },
      },
    }),
    [attractionCategory, id, apiClient],
  );

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Loading />
      </div>
    );
  }

  return (
    <AttractionTypesList
      config={attractionCategoryAttractionTypesConfig}
      className="p-0"
      baseUrl="/attraction-types"
    />
  );
}
